module.exports = __webpack_public_path__ + "img/swiper1.495e7072.png";